import { Box, IconButton, TextareaAutosize, Typography } from "@mui/material";

import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";

import { MicrophoneIcon, SendIcon } from "../../components/Icons/Icons";
import { SoundWave } from "../../components/Icons/SoundWave";

// import { getStorageValue } from "../../core/useLocalStorageForChat";

export const ChatInputBar = ({
  listening,
  elapsedTime,
  inputMessage,
  handleInputChange,
  messageInputRef,
  handlePaste,
  isWorking,
  onStopRecording,
  setChatVoiceModeOn,
  sendChatCompletion,
  handleVoiceButtonClick,
  isBigChatFlag,
  isZeroCurrentMessages,
  audioMode,
}) => {
  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={(theme) => ({
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          background: `linear-gradient(${theme.palette.background.paper}, ${theme.palette.background.paper}) padding-box, linear-gradient(to right, ${theme.palette.primary.light}, ${theme.palette.secondary.light}) border-box`,
          borderRadius: ".5em",
          border: "2px solid transparent",
          fontSize: "16px",
          overflow: "hidden",
        })}
      >
        {listening ? (
          <Box
            sx={{
              display: "flex",
              alignItems: isBigChatFlag ? "start" : "center",
              justifyContent: "space-between",
              height: isBigChatFlag && isZeroCurrentMessages ? "100px" : "56px",
              width: "100%",
              padding: "12px 10px 12px 16px",
            }}
          >
            <Typography sx={{ fontWeight: 500 }} color={elapsedTime > 22 ? "error" : "text.primary"}>
              {Math.floor(elapsedTime / 60)}:{(elapsedTime % 60).toString().padStart(2, "0")}
            </Typography>
            <SoundWave sx={{ height: 29, width: 72 }} />
            <Typography
              variant="overline"
              color="primary"
              sx={{
                cursor: "pointer",
                textTransform: "uppercase",
                fontSize: "14px",
                "[data-mui-color-scheme='dark'] &": {
                  color: "primary.light",
                },
              }}
              onClick={() => {
                onStopRecording();
                setChatVoiceModeOn(false);
              }}
            >
              Cancel
            </Typography>
            <IconButton
              onClick={() => {
                if (inputMessage.trim()) {
                  sendChatCompletion(inputMessage);
                }
              }}
              disabled={isWorking}
              sx={{
                backgroundColor: "secondary.light",
                color: "white",
                "&:hover": { backgroundColor: "colors.backgroundAmber" },
                width: "36px",
                height: "36px",
              }}
            >
              <SendIcon color="white" />
            </IconButton>
          </Box>
        ) : (
          <>
            <div
              style={{
                flex: 1,
                height: isBigChatFlag ? "100px" : "56px",
                display: "flex",
                alignItems: isBigChatFlag ? "start" : "center",
                paddingRight: "100px",
              }}
            >
              <TextareaAutosize
                placeholder="Hey, Tilley..."
                name="message"
                id="message"
                maxRows={4}
                style={{
                  width: "100%",
                  resize: "none",
                  background: "var(--mui-palette-background-paper)",
                  color: "var(--mui-palette-text-primary)",
                  border: "none",
                  outline: "none",
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "1.2",
                  padding: "12px 16px",
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" && !event.shiftKey && !event.ctrlKey && inputMessage.trim()) {
                    sendChatCompletion(inputMessage);
                  }
                }}
                autoFocus={true}
                ref={messageInputRef}
                onChange={(event) => handleInputChange(event.target.value)}
                value={inputMessage}
                disabled={isWorking}
                onPaste={handlePaste}
              />
            </div>
            <Box sx={{ position: "absolute", right: "12px", bottom: "12px", display: "flex", gap: "8px" }}>
              {audioMode && (
                <IconButton
                  onClick={handleVoiceButtonClick}
                  disabled={isWorking}
                  sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    "&:hover": { backgroundColor: "primary.main" },
                    width: "36px",
                    height: "36px",
                  }}
                >
                  <MicrophoneIcon color="white" />
                </IconButton>
              )}
              <IconButton
                onClick={() => {
                  if (inputMessage.trim()) {
                    sendChatCompletion(inputMessage);
                  }
                }}
                disabled={isWorking}
                sx={{
                  backgroundColor: "secondary.main",
                  color: "white",
                  "&:hover": { backgroundColor: "secondary.main" },
                  width: "36px",
                  height: "36px",
                }}
              >
                <SendIcon color="white" />
              </IconButton>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};
